'use client';

import useNavigationState from 'src/components/Navigation/hooks/useNavigationState';
import useNavigationStore from 'src/stores/useNavigationStore';
import DesktopNavButton from 'src/components/Navigation/DesktopNav/DesktopNavButton';
import DesktopNavDropdown from 'src/components/Navigation/DesktopNav/DesktopNavDropdown/DesktopNavDropdown';
import useNavItems from 'src/components/Navigation/hooks/useNavItems';

export default function DesktopNav() {
	const navigationState = useNavigationState();
	const currentNavSelection = useNavigationStore(
		(s) => s.currentNavigationSelection
	);
	const currentNavCategory = useNavigationStore(
		(s) => s.currentNavigationCategory
	);

	const navItems = useNavItems({ screenSize: 'desktop' });

	return (
		<nav>
			<ul className="flex items-center gap-sm">
				{navItems.map(([navCategory, navOption]) => {
					const key = `${currentNavSelection}_${navCategory}`;
					const isActive = currentNavCategory === navCategory;

					const content = (() => {
						if (navOption.type === 'categoryOption') {
							return (
								<DesktopNavDropdown
									navOption={navOption}
									currentNavSelection={currentNavSelection}
									navCategory={navCategory}
									handleNavigation={navigationState.handleNavigation}
									isActive={isActive}
								/>
							);
						}

						return (
							<DesktopNavButton
								className={navOption.className}
								navOption={navOption}
								navCategory={navCategory}
								handleNavigation={navigationState.handleNavigation}
								isActive={isActive}
							/>
						);
					})();

					return <li key={key}>{content}</li>;
				})}
			</ul>
		</nav>
	);
}
